export default "__VITE_ASSET__dvjAn8NJj8wCzPtk49$E4A__"